import { createProxyClient } from '../../api/createProxyClient';

/**
 * ValiSight-API-Client (#261 P6). Immer über den BFF-Proxy `/proxy/valisight/...`
 * — das Frontend sieht das GATEWAY_SHARED_SECRET nie. Die Kurations-Routen
 * (`/v1/explain/*`) liegen hinter dem gateway-guard; der öffentliche Read
 * (`/v1/explanations`) läuft über allowPaths. Der BFF hängt in beiden Fällen das
 * Gateway-Secret an (bei allowPaths schadlos ignoriert).
 *
 * #116/#113: nutzt jetzt die gemeinsame createProxyClient-Fabrik statt einer
 * eigenen ofetch-Kopie — Signatur/Verhalten unverändert.
 */
const client = createProxyClient('valisight');

export const valisightFetch = client.fetch;
export const isValisightProxyEnabled = client.isEnabled;
